/**
 * Copyright © 2020-2023 Delicious AI, LLC
 *
 * @author Kyle Armstrong <kyle.armstrong@deliciousai.com>
 */

import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const {
  VITE_APP__FB_API_KEY,
  VITE_APP__FB_AUTH_DOMAIN,
  VITE_APP__FB_DATABASE_URL,
  VITE_APP__FB_PROJECT_ID,
  VITE_APP__FB_STORAGE_BUCKET,
  VITE_APP__FB_MAP_STORAGE_BUCKET,
  VITE_APP__MESSAGING_SENDER_ID,
  VITE_APP__OBJ_STORAGE_BUCKET,
  VITE_APP__APP_ID,
  VITE_APP_MEASUREMENT_ID,
} = import.meta.env

const firebaseConfig = {
  apiKey: VITE_APP__FB_API_KEY,
  authDomain: VITE_APP__FB_AUTH_DOMAIN,
  databaseURL: VITE_APP__FB_DATABASE_URL,
  projectId: VITE_APP__FB_PROJECT_ID,
  storageBucket: VITE_APP__FB_STORAGE_BUCKET,
  messagingSenderId: VITE_APP__MESSAGING_SENDER_ID,
  appId: VITE_APP__APP_ID,
  measurementId: VITE_APP_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const firestore = getFirestore(app)
export const storage = getStorage()
export const mapStorage = getStorage(
  app,
  `gs://${VITE_APP__FB_MAP_STORAGE_BUCKET}`,
)
export const imageStorage = getStorage(
  app,
  `gs://${VITE_APP__FB_PROJECT_ID}-images`,
)
export const videoStorage = getStorage(
  app,
  `gs://${VITE_APP__FB_PROJECT_ID}-videos`,
)
export const objStorage = getStorage(
  app,
  `gs://${VITE_APP__OBJ_STORAGE_BUCKET}`,
)
